import { useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useNotificationStore } from '../stores/useNotificationStore';
import { useAuthStore } from '../stores/useAuthStore';
import type { NotificationRecord } from '../types';

export function useRealtimeNotifications() {
  const user = useAuthStore((s) => s.user);
  const addNotification = useNotificationStore((s) => s.addNotification);

  useEffect(() => {
    if (!user) return;

    const channel = supabase
      .channel('notifications')
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'notifications',
          filter: `user_id=eq.${user.id}`,
        },
        (payload) => {
          const notification = payload.new as NotificationRecord;
          addNotification(notification);
        },
      )
      .subscribe();

    return () => {
      channel.unsubscribe();
    };
  }, [user, addNotification]);
}
